export const LOCALE = 'de-CH';
